import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { UiCoreComponentsModule, ScModalDialogService } from '@sc/claim-components';

// Components
import { ScContactInfoModalComponent } from './sc-contact-info-modal.component';

@NgModule({
  imports: [
    CommonModule,
    UiCoreComponentsModule,
    ReactiveFormsModule
  ],
  exports: [
    ScContactInfoModalComponent
  ],
  declarations: [
    ScContactInfoModalComponent
  ],
  providers: [
    ScModalDialogService
  ]
})
export class ScContactInfoModalModule { }
